(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ldc-color-product"]) return;
  try {
    
  (() => {
    const update = (select, persist) => {
      const root = select.closest('[data-ldc-color-product]');
      const option = select.selectedOptions?.[0] || select;
      if (!option) return;
      root.querySelector('[data-color-price]').textContent = option.dataset.price;
      root.querySelector('[data-color-unit]').textContent = option.dataset.saleUnit ? ' / ' + option.dataset.saleUnit : '';
      const button = root.querySelector('[data-color-buy]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
      if (persist) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url.href);
      }
    };
    const restore = (root) => {
      const variant = new URL(window.location.href).searchParams.get('variant');
      root.querySelectorAll('[data-color-variant]').forEach((select) => {
        if (variant && select.options && Array.from(select.options).some((option) => option.value === variant)) select.value = variant;
        update(select, false);
      });
    };
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-color-variant]')) update(event.target, true);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => restore(document), {once: true});
    else restore(document);
    document.addEventListener('shopify:section:load', (event) => restore(event.target));
    window.addEventListener('popstate', () => restore(document));
  })();
  if (!customElements.get('ldc-color-gallery')) {
    customElements.define('ldc-color-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.panels = Array.from(this.querySelectorAll('[data-ldc-gallery-panel]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-ldc-gallery-index]'));
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('[data-ldc-gallery-play]');
        this.index = 0;
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-ldc-gallery-index]');
          const arrow = event.target.closest('[data-ldc-gallery-step]');
          if (thumbnail) this.show(Number(thumbnail.dataset.ldcGalleryIndex));
          if (arrow) this.show(this.index + Number(arrow.dataset.ldcGalleryStep));
          if (event.target.closest('[data-ldc-gallery-play]')) this.video?.play().catch(() => { this.playButton.hidden = false; });
        });
        this.addEventListener('keydown', (event) => {
          if (!event.target.closest('[data-ldc-gallery-index]')) return;
          let next = this.index;
          if (event.key === 'ArrowRight') next += 1;
          else if (event.key === 'ArrowLeft') next -= 1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.panels.length - 1;
          else return;
          event.preventDefault();
          this.show(next);
          this.thumbnails[this.index].focus();
        });
        this.video?.addEventListener('play', () => { this.playButton.hidden = true; });
        this.video?.addEventListener('pause', () => { this.playButton.hidden = false; });
        this.video?.addEventListener('ended', () => { this.playButton.hidden = false; });
      }
      show(index) {
        this.index = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, position) => { panel.hidden = position !== this.index; });
        this.thumbnails.forEach((button, position) => button.setAttribute('aria-pressed', String(position === this.index)));
        if (!this.panels[this.index].querySelector('video')) this.video?.pause();
      }
      disconnectedCallback() { this.video?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ldc-related-products"]) return;
  try {
    
  (() => {
    const enhance = (root) => {
      const sections = root.matches?.('[data-ldc-related]') ? [root] : root.querySelectorAll('[data-ldc-related]');
      sections.forEach((section) => {
        if (section.dataset.mode === 'automatic' || section.dataset.requested) return;
        section.dataset.requested = 'true';
        const load = async () => {
          try {
            const response = await fetch(section.dataset.url, {credentials: 'same-origin'});
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const replacement = html.querySelector('[data-ldc-related][data-mode="automatic"]');
            if (!replacement?.querySelector('.ldc-related__card')) return;
            if (section.contains(document.activeElement)) return;
            section.replaceWith(replacement);
          } catch {}
        };
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              observer.disconnect();
              load();
            }
          }, {rootMargin: '300px'});
          observer.observe(section);
        } else load();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once:true});
    else enhance(document);
    document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ldc-whatsapp-links"]) return;
  try {
    

  (() => {
    const isWhatsApp = (link) => {
      try {
        const url = new URL(link.getAttribute('href'), document.baseURI);
        return ['http:', 'https:'].includes(url.protocol) && (url.hostname === 'wa.me' || url.hostname === 'whatsapp.com' || url.hostname.endsWith('.whatsapp.com'));
      } catch { return false; }
    };
    const update = (link) => {
      if (!isWhatsApp(link)) return;
      link.target = '_blank';
      link.relList.add('noopener', 'noreferrer');
    };
    const scan = (root) => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      if (root.matches?.('a[href]')) update(root);
      root.querySelectorAll('a[href]').forEach(update);
    };
    scan(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') update(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href]');
      if (link) update(link);
    }, true);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  } catch(e) { console.error(e); }
})();
})();
